import React from "react";

function About() {
  return (
    <div className="about-page">
      <div className="two-column-layout">
        <div className="column_left">
          <img
            src="/horseandpony_about_image.jpg"
            alt="Horse & Pony Directors"
            style={{ width: "100%", height: "auto" }}
          />
          <h1>About Us</h1>
          <p className="about_text">
            {"Founded by artists "}
            <a
              href="https://carrickbell.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              carrick bell
            </a>
            {" and "}
            <a
              href="https://michaelrocco.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Rocco Ruglio-Misurell
            </a>
            {
              ", Horse & Pony is an artist-run space with the aim of providing artists, curators, and other project spaces the opportunity to extend or act outside of their existing practices."
            }
            <br />
            <br />
            Since 2021, Horse & Pony has been focused on projects in the
            basement and external locations. The front of the gallery is used
            for our parallel project{" "}
            <a
              href="https://xanadu.berlin/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Xanadu
            </a>
            , which is focused on artists' moving image works.
          </p>
        </div>
        <div className="column_right">
          <div>
            <br />
            <h1>Selected Press Links</h1>
            <br />
            <br />
            <a
              href="https://www.berlinartlink.com/2022/01/04/horse-and-pony-eight-year-anniversary-exhibition-stampede-review/"
              target="_blank"
              rel="noopener noreferrer"
            >
              04.01.2022
              <br /> Reflecting On Eight Years: ‘Stampede’ at Horse & Pony{" "}
              <br />
              text by Alice Connolly O’Brien <br /> Berlin Art Link
            </a>
            <br />
            <br />
            <a
              href="https://www.gallerytalk.net/horse-and-pony-carrick-bell-rocco-ruglio-misurell-interview/"
              target="_blank"
              rel="noopener noreferrer"
            >
              27.11.2021 <br /> Große Inszenierung, begrenzte Mittel – Horse &
              Pony von damals bis morgen <br /> text by Anna Meinecke <br />
              gallerytalk.net
            </a>
            <br />
            <br />
            <a
              href="https://www.gallerytalk.net/in-der-hoelle-werden-traeume-wahr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              09.05.2021 <br /> In der Hölle werden Träume wahr – "Hell, Yes!"
              bei Horse & Pony <br /> text by Lara Brörken <br />{" "}
              gallerytalk.net
            </a>
            <br />
            <br />
            <a
              href="http://temporaryartreview.com/a-horse-pony-story/"
              target="_blank"
              rel="noopener noreferrer"
            >
              25.01.2019 <br /> A Horse & Pony Story <br /> text by Patrick J.
              Reed <br />
              Temporary Art Review
            </a>
            <br />
            <br />
            <a
              href="https://taz.de/Ausstellungsempfehlung-fuer-Berlin/!5556012/"
              target="_blank"
              rel="noopener noreferrer"
            >
              17.12.2018 <br /> Der paradoxe Lauf der Dinge <br /> text by
              Sophie Jung <br />
              taz
            </a>
            <br />
            <br />
            <a
              href="https://taz.de/!5503922/"
              target="_blank"
              rel="noopener noreferrer"
            >
              17.05.2018 <br /> Beate Schederschaut Sich In Berlin Galerien Um{" "}
              <br /> text by unknown <br /> taz
            </a>
            <br />
            <br />
            <a
              href="https://www.sleek-mag.com/article/best-berlin-art-shows-2017/"
              target="_blank"
              rel="noopener noreferrer"
            >
              20.12.2017 <br /> Berlin’s 13 Best Art Shows of 2017 <br /> text
              by Sophia Lawler-Dormer <br /> Sleek
            </a>
            <br />
            <br />
            <a
              href="https://lolamag.de/feature/art-feature/the-artists-who-turned-a-doner-factory-into-a-contemporary-art-space/"
              target="_blank"
              rel="noopener noreferrer"
            >
              13.11.2017 <br /> Waves, Sand, and Sunlight <br /> text by Alison
              Rhoades <br />
              LOLA Magazine
            </a>
            <br />
            <br />
            <a
              href="http://www.covenberlin.com/a-new-prescription-for-insomnia/"
              target="_blank"
              rel="noopener noreferrer"
            >
              21.05.2017 <br /> A New Prescription for Insomnia <br /> interview
              by Lo Pecado <br /> Coven
            </a>
            <br />
            <br />
            <a
              href="https://www.berlinartlink.com/2017/03/20/exhibition-other-oracles-at-horseandpony/"
              target="_blank"
              rel="noopener noreferrer"
            >
              20.05.2017 <br /> Exhibition // ‘Other Oracles’ at HORSEANDPONY{" "}
              <br /> text by Candice Nembhard <br /> Berlin Art Link
            </a>
            <br />
            <br />
            <a
              href="https://www.artsy.net/article/artsy-editorial-the-berlin-artist-run-galleries-you-need-know"
              target="_blank"
              rel="noopener noreferrer"
            >
              31.12.2016 <br /> The Berlin Artist-Run Galleries You Need to Know{" "}
              <br />
              text by Arielle Bier <br /> Artsy
            </a>
            <br />
            <br />
            <a
              href="http://lolamag.de/feature/art-feature/the-artists-who-turned-a-doner-factory-into-a-contemporary-art-space/"
              target="_blank"
              rel="noopener noreferrer"
            >
              2016 <br /> The Artists Who Turned a Döner Factory Into a
              Contemporary Art Space <br /> text by Alison Rhoades <br /> LOLA
              Magazine
            </a>
            <br />
            <br />
            <a
              href="http://www.dazeddigital.com/artsandculture/article/23929/1/rebuilding-the-body-in-the-post-digital-age"
              target="_blank"
              rel="noopener noreferrer"
            >
              06.03.2016 <br /> Rebuilding the Body in the Post-Digital Age{" "}
              <br /> text by Mandalena Munkonge <br /> Dazed
            </a>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
